import React, { useEffect, useState } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Header } from './components/Header';
import { Hero } from './components/Hero';
import { Story } from './components/Story';
import { ServiceGrid } from './components/ServiceGrid';
import { MenuExperience } from './components/MenuExperience';
import { Footer } from './components/Footer';
import { QuoteModal } from './components/QuoteModal';
import { ServiceDetail } from './pages/ServiceDetail';
import { OurEvents } from './pages/OurEvents';
import { EventDetail } from './pages/EventDetail';
import { Gallery } from './components/Gallery';
import { Contact } from './pages/Contact';
import { PrivacyPolicy } from './pages/PrivacyPolicy';
import { TermsOfService } from './pages/TermsOfService';
const tieredPackages = [{
  name: 'Buffet',
  features: ['Entree - Up to 3 Selections', 'Sides - Up to 3 Selections', 'Apps - Up to 1 Selection', 'Hand-craft Drink - Up to 2'],
  pricing: [{
    guests: '10-15',
    price: '$2,000 - 4,000'
  }, {
    guests: '20-40',
    price: '$4,500 - 6,800'
  }, {
    guests: '40-60',
    price: '$7,200 - 9,600'
  }, {
    guests: '60-100',
    price: '$9,800 - 15,000'
  }]
}, {
  name: 'Canapes & Drinks',
  features: ['Apps - Up to 5 Selections', 'Drinks - Up to 4 Selections'],
  pricing: [{
    guests: '10-15',
    price: '$1,500 - 2,500'
  }, {
    guests: '20-40',
    price: '$2,800 - 4,800'
  }, {
    guests: '40-60',
    price: '$5,000 - 7,000'
  }, {
    guests: '60-100',
    price: '$7,500 - 12,000'
  }]
}, {
  name: 'Weddings',
  features: ['Entree - Up to 4 Selections', 'Sides - Up to 4 Selections', 'Apps - Up to 2 Selections', 'Hand-craft Drink - Up to 4'],
  pricing: [{
    guests: '10-15',
    price: '$4,500 - 6,500'
  }, {
    guests: '20-40',
    price: '$6,800 - 8,500'
  }, {
    guests: '40-60',
    price: '$9,000 - 12,500'
  }, {
    guests: '60-100',
    price: '$15,000 - 25,000'
  }]
}];
const standardPackages = [{
  name: 'Private Chef Experience',
  price: '$200/pp',
  features: ['Entree', 'Sides', 'Brunch', 'Beverages']
}, {
  name: 'Drop off - Deliver',
  price: '$40/pp',
  features: ['Entree', 'Sides', 'Brunch']
}, {
  name: 'Corporate - Office Meal',
  price: '$65/pp',
  features: ['Entree', 'Sides', 'Brunch', 'Beverages']
}];
function HomePage({
  openQuote
}: {
  openQuote: (item?: string) => void;
}) {
  return <>
      <Hero onOpenQuote={() => openQuote()} data-id="element-0" />

      {/* Trusted By Section */}
      <section className="py-12 bg-white border-b border-gray-100" data-id="element-1">
        <div className="max-w-7xl mx-auto px-6 text-center" data-id="element-2">
          <p className="text-xs font-bold uppercase tracking-widest text-gray-400 mb-8" data-id="element-3">
            Trusted By Esteemed Organizations
          </p>
          <div className="flex flex-wrap justify-center items-center gap-16 md:gap-24" data-id="element-4">
            <img src="https://cdn.magicpatterns.com/uploads/tv9VZrNA2xtHJmabDKFP3B/clasp_logo-700x330.webp" alt="CLASP - The Center for Law and Social Policy" className="h-12 md:h-16 w-auto object-contain grayscale opacity-60 hover:grayscale-0 hover:opacity-100 transition-all duration-500" data-id="element-5" />
            <img src="https://cdn.magicpatterns.com/uploads/ubgaSBCrVoZ9qY1EcQjh2B/images.png" alt="Maryland Women's Caucus" className="h-16 md:h-20 w-auto object-contain grayscale opacity-60 hover:grayscale-0 hover:opacity-100 transition-all duration-500" data-id="element-6" />
          </div>
        </div>
      </section>

      <Story isCompact={true} data-id="element-7" />

      {/* Impact & Statistics Section */}
      <section className="py-16 md:py-24 bg-brand-black text-white relative overflow-hidden" data-id="element-8">
        <div className="absolute inset-0 opacity-10 bg-[url('https://images.unsplash.com/photo-1555244162-803834f70033?auto=format&fit=crop&q=80&w=2000')] bg-cover bg-center mix-blend-overlay" data-id="element-9" />
        <div className="max-w-7xl mx-auto px-6 relative z-10" data-id="element-10">
          <div className="grid lg:grid-cols-3 gap-12 items-center" data-id="element-11">
            <div className="lg:col-span-1 text-center lg:text-left" data-id="element-12">
              <span className="text-brand-gold font-bold tracking-[0.3em] uppercase text-xs mb-4 block" data-id="element-13">
                Versatile LLC
              </span>
              <h2 className="text-3xl md:text-4xl font-serif mb-6 leading-tight" data-id="element-14">
                We make sure your orders are delivered on time.
              </h2>
              <p className="text-gray-400 text-xl italic font-serif" data-id="element-15">
                "We do it for you with love."
              </p>
            </div>
            <div className="lg:col-span-2 grid grid-cols-2 md:grid-cols-3 gap-6 md:gap-8" data-id="element-16">
              {[{
              value: '2023',
              label: 'Founding Year'
            }, {
              value: '200+',
              label: 'Happy Customers'
            }, {
              value: '4',
              label: 'Countries Worked With'
            }, {
              value: '5',
              label: 'Team Members'
            }, {
              value: '12+',
              label: 'Events Hosted'
            }, {
              value: '50+',
              label: 'Food List Items'
            }].map((stat, idx) => <div key={idx} className="text-center p-6 border border-white/10 rounded-sm bg-white/5 backdrop-blur-sm hover:border-brand-gold/50 transition-colors group" data-id="element-17">
                  <div className="text-3xl md:text-4xl font-bold text-brand-gold mb-2 group-hover:scale-110 transition-transform duration-300" data-id="element-18">
                    {stat.value}
                  </div>
                  <div className="text-[10px] md:text-xs font-bold uppercase tracking-widest text-gray-300" data-id="element-19">
                    {stat.label}
                  </div>
                </div>)}
            </div>
          </div>
        </div>
      </section>

      <ServiceGrid onOpenQuote={service => openQuote(service)} data-id="element-20" />

      {/* Visual Pricing Guide Section */}
      <section className="py-20 md:py-32 bg-brand-black text-white relative overflow-hidden" data-id="element-21">
        <div className="absolute inset-0 opacity-20 bg-[url('https://images.unsplash.com/photo-1414235077428-338989a2e8c0?auto=format&fit=crop&q=80&w=2000')] bg-cover bg-center mix-blend-overlay" data-id="element-22" />

        <div className="max-w-7xl mx-auto px-6 relative z-10" data-id="element-23">
          <div className="text-center mb-16" data-id="element-24">
            <span className="text-brand-gold font-bold tracking-[0.3em] uppercase text-xs mb-4 block" data-id="element-25">
              Luxe Catering Set Up
            </span>
            <h2 className="text-4xl md:text-5xl font-serif mb-6 text-white" data-id="element-26">
              Catering Style Packages
            </h2>
            <p className="text-gray-400 text-lg max-w-2xl mx-auto" data-id="element-27">
              A comprehensive guide to our catering styles and tiered pricing
              groups. All set-up services include luxe decorations.
            </p>
          </div>

          {/* Tiered Packages */}
          <div className="grid lg:grid-cols-3 gap-8 mb-12" data-id="element-28">
            {tieredPackages.map((pkg, idx) => <div key={idx} className="bg-white/5 border border-white/10 rounded-sm p-8 hover:border-brand-gold/50 transition-colors backdrop-blur-sm flex flex-col" data-id="element-29">
                <h3 className="text-2xl font-serif text-brand-gold mb-6 text-center" data-id="element-30">
                  {pkg.name}
                </h3>
                <ul className="space-y-3 mb-8 flex-grow" data-id="element-31">
                  {pkg.features.map((feature, fIdx) => <li key={fIdx} className="text-sm text-gray-300 flex items-start gap-3" data-id="element-32">
                      <span className="text-brand-gold mt-0.5 text-lg leading-none" data-id="element-33">
                        •
                      </span>
                      <span data-id="element-34">{feature}</span>
                    </li>)}
                </ul>
                <div className="border-t border-white/10 pt-6" data-id="element-35">
                  <h4 className="text-xs font-bold uppercase tracking-widest text-gray-500 mb-4 text-center" data-id="element-36">
                    Groups & Pricing
                  </h4>
                  <div className="space-y-3" data-id="element-37">
                    {pkg.pricing.map((tier, tIdx) => <div key={tIdx} className="flex justify-between items-center text-sm border-b border-white/5 pb-2 last:border-0 last:pb-0" data-id="element-38">
                        <span className="text-gray-400" data-id="element-39">
                          {tier.guests} Guests
                        </span>
                        <span className="font-bold text-white" data-id="element-40">
                          {tier.price}
                        </span>
                      </div>)}
                  </div>
                </div>
              </div>)}
          </div>

          {/* Standard Packages */}
          <div className="grid md:grid-cols-3 gap-8 mb-16" data-id="element-41">
            {standardPackages.map((pkg, idx) => <div key={idx} className="bg-brand-gold/10 border border-brand-gold/20 rounded-sm p-8 text-center hover:bg-brand-gold/20 transition-colors backdrop-blur-sm" data-id="element-42">
                <h3 className="text-xl font-serif text-white mb-2" data-id="element-43">
                  {pkg.name}
                </h3>
                <div className="text-3xl font-bold text-brand-gold mb-6" data-id="element-44">
                  {pkg.price}
                </div>
                <div className="text-xs font-bold uppercase tracking-widest text-gray-400 mb-4" data-id="element-45">
                  Selections From:
                </div>
                <ul className="flex flex-wrap justify-center gap-3" data-id="element-46">
                  {pkg.features.map((feature, fIdx) => <li key={fIdx} className="text-sm text-gray-300 bg-white/5 px-3 py-1 rounded-full border border-white/10" data-id="element-47">
                      {feature}
                    </li>)}
                </ul>
              </div>)}
          </div>

          <div className="text-center" data-id="element-48">
            <button onClick={() => openQuote()} className="bg-brand-gold text-white px-10 py-5 rounded-sm text-sm font-bold uppercase tracking-widest hover:bg-white hover:text-brand-black transition-all duration-300 shadow-xl" data-id="element-49">
              Start Your Custom Quote
            </button>
          </div>
        </div>
      </section>

      <MenuExperience onSelectItem={item => openQuote(item)} isCompact={true} data-id="element-50" />
      <Gallery data-id="element-51" />
    </>;
}
function ServicesPage({
  openQuote
}: {
  openQuote: (item?: string) => void;
}) {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return <div className="pt-24 min-h-screen bg-gray-50" data-id="element-52">
      <ServiceGrid onOpenQuote={openQuote} data-id="element-53" />
    </div>;
}
function MenuPage({
  openQuote
}: {
  openQuote: (item?: string) => void;
}) {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return <div className="pt-24 min-h-screen bg-white" data-id="element-54">
      <MenuExperience onSelectItem={openQuote} data-id="element-55" />
    </div>;
}
function StoryPage() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return <div className="pt-24 min-h-screen bg-white" data-id="element-56">
      <Story data-id="element-57" />
    </div>;
}
function ContactPage() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return <div className="pt-32 pb-24 min-h-[60vh] bg-gray-50 flex flex-col items-center justify-center px-6 text-center" data-id="element-58">
      <h1 className="text-4xl md:text-5xl font-serif mb-6" data-id="element-59">Get in Touch</h1>
      <p className="text-gray-600 max-w-2xl mb-8" data-id="element-60">
        We would love to hear from you. Whether you're planning a grand wedding
        or a corporate luncheon, our team is ready to bring your vision to life.
      </p>
      <div className="flex flex-col md:flex-row gap-8 text-left" data-id="element-61">
        <div className="bg-white p-8 rounded-sm shadow-sm border border-gray-100 w-full md:w-64" data-id="element-62">
          <h3 className="font-bold text-brand-black mb-2" data-id="element-63">Email Us</h3>
          <p className="text-gray-500" data-id="element-64">hello@versatilityeats.com</p>
        </div>
        <div className="bg-white p-8 rounded-sm shadow-sm border border-gray-100 w-full md:w-64" data-id="element-65">
          <h3 className="font-bold text-brand-black mb-2" data-id="element-66">Call Us</h3>
          <p className="text-gray-500" data-id="element-67">(202) 555-0123</p>
        </div>
      </div>
    </div>;
}
export function App() {
  const [isQuoteModalOpen, setIsQuoteModalOpen] = useState(false);
  const [selectedItem, setSelectedItem] = useState<string | undefined>(undefined);
  const openQuote = (item?: string) => {
    setSelectedItem(item);
    setIsQuoteModalOpen(true);
  };
  return <BrowserRouter data-id="element-68">
      <div className="min-h-screen flex flex-col" data-id="element-69">
        <Header onOpenQuote={() => openQuote()} data-id="element-70" />
        <main className="flex-grow" data-id="element-71">
          <Routes data-id="element-72">
            <Route path="/" element={<HomePage openQuote={openQuote} data-id="element-74" />} data-id="element-73" />
            <Route path="/services" element={<ServicesPage openQuote={openQuote} data-id="element-76" />} data-id="element-75" />
            <Route path="/menu" element={<MenuPage openQuote={openQuote} data-id="element-78" />} data-id="element-77" />
            <Route path="/events" element={<OurEvents openQuote={openQuote} data-id="element-80" />} data-id="element-79" />
            <Route path="/events/:id" element={<EventDetail openQuote={openQuote} data-id="element-82" />} data-id="element-81" />
            <Route path="/story" element={<StoryPage data-id="element-84" />} data-id="element-83" />
            <Route path="/contact" element={<Contact data-id="element-86" />} data-id="element-85" />
            <Route path="/privacy-policy" element={<PrivacyPolicy data-id="element-88" />} data-id="element-87" />
            <Route path="/terms-of-service" element={<TermsOfService data-id="element-90" />} data-id="element-89" />
            <Route path="/services/:id" element={<ServiceDetail openQuote={openQuote} data-id="element-92" />} data-id="element-91" />
          </Routes>
        </main>
        <Footer onOpenQuote={() => openQuote()} data-id="element-93" />
        <QuoteModal isOpen={isQuoteModalOpen} onClose={() => setIsQuoteModalOpen(false)} initialItem={selectedItem} data-id="element-94" />
      </div>
    </BrowserRouter>;
}